var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6864 1.63978C14.5135 0.993992 14.006 0.4865 13.3602 0.313632C12.1909 9.38817e-08 7.49997 0 7.49997 0C7.49997 0 2.8091 9.38817e-08 1.63977 0.313632C0.993992 0.4865 0.4865 0.993992 0.313632 1.63978C9.38817e-08 2.8091 0 5.25024 0 5.25024C0 5.25024 9.38817e-08 7.6914 0.313632 8.86073C0.4865 9.50651 0.993992 10.014 1.63977 10.1868C2.8091 10.5005 7.49997 10.5005 7.49997 10.5005C7.49997 10.5005 12.1909 10.5005 13.3602 10.1868C14.006 10.014 14.5135 9.50651 14.6864 8.86073C15 7.6914 15 5.25024 15 5.25024C15 5.25024 14.9987 2.8091 14.6864 1.63978Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 7.5034L9.89499 5.25367L5.99805 3.00391V7.5034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e96d685bf1ea91ea11afa3880b25ec58.svg";
export { ForwardRef as ReactComponent };